import React from "react";
import Hero from "./Hero/Hero";
import History from "./History";
import Advantages from "./Advantages";
import Hiring from "./Hiring";
import Media from "./Media/Media";
import HowToHelp from "./HowToHelp";
import MediaFeed from "./MediaFeed";
import { Helmet } from "react-helmet-async";

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>210 Окремий Штурмовий Полк | Головна</title>
        <meta name="description" content="Офіційний сайт 210-го окремого штурмового полку Сухопутних війск Збройних сил України."/>
      </Helmet>

      <div style={styles.mainWrapper}>
        <img
          src={"/210-preview.png"}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            opacity: 0.001,
            userSelect: "none",
            pointerEvents: "none",
            zIndex: "999999"
          }}
          alt="logo"
        />
        <Hero/>
        <History/>
        <Advantages/>
        <Hiring/>
        <Media/>
        {/* <MediaFeed /> */}
        <HowToHelp/>
      </div>
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  mainWrapper: {
    overflowX: "hidden",
  },
};

export default HomePage;
